import useAuthority from "../hooks/useAuthority";
import { AUTHORITY_TYPE, MODULES } from "../const";

const WizardTab = ({
  submitted = false,
  nextValidated = false,
  errors = false,
  active,
  onClick,
  title,
  description,
  icon,
  form = "",
  authenticated = false,
  module = MODULES.Transaction,
  showMandatory = false,
  isMandatory = false,
}) => {
  const { view } = useAuthority({
    type: AUTHORITY_TYPE.FORM,
    module,
    form,
    editMode: false,
    authenticated: authenticated,
  });
  return (
    <div
      style={
        view
          ? {
              backgroundColor:
                (submitted || nextValidated) && errors ? "#ebd7d7" : "",
            }
          : { display: "none" }
      }
      className={`step ${active ? "active" : ""}`}
      onClick={onClick}
    >
      <div
        style={
          showMandatory
            ? {
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                borderRadius: "100%",
                padding: "20px",
                backgroundColor: `${(submitted || nextValidated) && errors ? "#e0b4b4" : isMandatory ? "#B4e0b4" : ""}`,
                height: "50px",
                width: "50px",
                marginRight: "5px",
              }
            : {
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "50px",
                width: "50px",
              }
        }
      >
        <i className={icon} style={{ fontSize: "2em" }}></i>
      </div>

      <div className="content">
        <div className="title">{title}</div>
        <div className="description">{description}</div>
      </div>
    </div>
  );
};

export default WizardTab;
